import React, { ComponentType, ElementType } from "react";
import { Button, Grid, Typography } from "@mui/material";
import { Link } from "react-router";
import { getProductData } from "@/src/services/productService";
import { translate } from "@/src/services/translations/translations";
import { MinimalCase } from "@/src/types/Entities/MinimalCase";
import { Box } from "@mui/system";
import { ButtonProps } from "@mui/material/Button";
import ProductBox from "@/src/components/ProductBox/ProductBox";

type ServiceWorldCaseItemProps = {
  minimalCase: MinimalCase;
  NotificationComponent?: ComponentType<{ minimalCase: MinimalCase }> | null;
  listItemButtonConfig?: { getLink?: Function; handleClick?: Function };
};

const ServiceWorldCaseItem = ({ minimalCase, listItemButtonConfig = {}, NotificationComponent = null }: ServiceWorldCaseItemProps) => {
  const isLink = !!listItemButtonConfig.getLink;
  let buttonProps: Partial<ButtonProps & { component?: ElementType; to?: string }> = {};

  if (isLink && listItemButtonConfig?.getLink) {
    buttonProps.component = Link;
    buttonProps.to = listItemButtonConfig.getLink(minimalCase);
  }
  if (!!listItemButtonConfig.handleClick) {
    buttonProps.onClick = () => listItemButtonConfig.handleClick?.(minimalCase);
  }

  const renderHeadline = () => {
    let title = getProductData(minimalCase.name, "productCategory.label");
    if (minimalCase.productCategory === "administrativeLaw" && minimalCase.administrativeCaseType !== "main") {
      title += " - " + translate(`${minimalCase.name}.administrativeCaseType.${minimalCase.administrativeCaseType}.label`, minimalCase);
    }
    if ((minimalCase.instanceLevel || 0) > 0) {
      title += " - " + translate(minimalCase.name + ".instanceLevel", minimalCase);
    }
    return title;
  };

  return (
    <ProductBox headline={renderHeadline()} variant={"divider"}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: "grow" }}>
          <Box>
            <Typography>
              {getProductData(minimalCase.name, "label")}
              {minimalCase.opposingParty ? ` | ${minimalCase.opposingParty}` : ""}
            </Typography>
            <Typography>Fallnummer: {minimalCase.reference}</Typography>
          </Box>
        </Grid>

        <Grid size={{ xs: 12, sm: "auto" }} sx={{ display: "flex", justifyContent: { xs: "center", sm: "flex-end" }, alignItems: "flex-end" }}>
          <Button variant={"outlined"} {...buttonProps} sx={{ width: { xs: "100%", sm: "12rem" } }} size={"small"}>
            Fall öffnen
          </Button>
        </Grid>

        {NotificationComponent && <NotificationComponent minimalCase={minimalCase} />}
      </Grid>
    </ProductBox>
  );
};

export default ServiceWorldCaseItem;
